module.exports = __webpack_public_path__ + "static/img/videoPic2.e4a45a84.png";